export default {
    message: {
        impersonation: "Ön a(z) «{name}» nevében rendel."
    }
}